export const environment = {
    APIEndpoint: "https://quoteapi.dev.mfg.com/api/",
    DynamoDBAPI: "https://quotenetapi.dev.mfg.com/api/",
    s3BaseUrl: "https://quote-assist-demo-videos.s3.us-east-2.amazonaws.com",
    production: false,
    environmentName: 'dev',
    sentry: {
        dsn: "https://b65b7c6a065f48d05be4a14126d091cd@o4507262598316032.ingest.us.sentry.io/4509447313555456",
        environment: 'dev',
        tracesSampleRate: 1.0
    },
    mixpanel: {
        token: '821632dbab87d76ec9b24d3251deb7a1',
        apiHost: 'https://livemfg.com'
    }
}